var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSafety1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 44,
    viewBox: "0 0 41 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95715 39H13.4572V26.5C13.4572 25.7917 13.6972 25.1983 14.1772 24.72C14.6572 24.2417 15.2505 24.0017 15.9572 24H25.9572C26.6655 24 27.2597 24.24 27.7397 24.72C28.2197 25.2 28.4588 25.7933 28.4572 26.5V39H35.9572V16.5L20.9572 5.25L5.95715 16.5V39ZM0.957153 39V16.5C0.957153 15.7083 1.13465 14.9583 1.48965 14.25C1.84465 13.5417 2.33382 12.9583 2.95715 12.5L17.9572 1.25C18.8322 0.583334 19.8322 0.25 20.9572 0.25C22.0822 0.25 23.0822 0.583334 23.9572 1.25L38.9572 12.5C39.5822 12.9583 40.0722 13.5417 40.4272 14.25C40.7822 14.9583 40.9588 15.7083 40.9572 16.5V39C40.9572 40.375 40.4672 41.5525 39.4872 42.5325C38.5072 43.5125 37.3305 44.0017 35.9572 44H25.9572C25.2488 44 24.6555 43.76 24.1772 43.28C23.6988 42.8 23.4588 42.2067 23.4572 41.5V29H18.4572V41.5C18.4572 42.2083 18.2172 42.8025 17.7372 43.2825C17.2572 43.7625 16.6638 44.0017 15.9572 44H5.95715C4.58215 44 3.40549 43.5108 2.42715 42.5325C1.44882 41.5542 0.95882 40.3767 0.957153 39Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety1);
export default __webpack_public_path__ + "static/media/safety_1.9f68b9993f17033df001893ac91aaa60.svg";
export { ForwardRef as ReactComponent };